import React from 'react';
import {Avatar, Box, Chip, Stack, Typography} from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';

// AI Author configuration
const AI_AUTHOR = {
    uid: 'ai',
    displayName: 'AI Assistant',
    isAI: true
};

/**
 * Authors field component to display document authors
 * @param {Object} props
 * @param {Array} props.authors - Array of author objects with {uid, displayName, headshot}
 */
export default function AuthorsField({authors = []}) {
    if (!authors || authors.length === 0) {
        return (
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5}}>
                <Typography variant="body2" color="text.secondary" sx={{minWidth: '150px', flexShrink: 0}}>
                    Authors:
                </Typography>
                <Typography variant="body1" color="text.disabled" sx={{flex: 1, minWidth: 0}}>
                    Authors are generated from text attribution.
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{display: 'flex', alignItems: 'flex-start', gap: 1.5}}>
            <Typography variant="body2" color="text.secondary" sx={{minWidth: '150px', pt: 0.5, flexShrink: 0}}>
                Authors:
            </Typography>
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{flex: 1, minWidth: 0}}>
                {authors.map((author, index) => {
                    const isAI = author.uid === 'ai' || author.isAI;

                    return (
                        <Chip
                            key={author.uid || index}
                            avatar={
                                isAI ? (
                                    <Avatar sx={{bgcolor: 'white'}}>
                                        <SmartToyIcon sx={{fontSize: 16}}/>
                                    </Avatar>
                                ) : author.headshot ? (
                                    <Avatar src={author.headshot} alt={author.displayName}/>
                                ) : (
                                    <Avatar>{author.displayName?.charAt(0) || '?'}</Avatar>
                                )
                            }
                            label={author.displayName || (isAI ? AI_AUTHOR.displayName : 'Unknown Author')}
                            variant={'outlined'}
                            color={'default'}
                            sx={{
                                '& .MuiChip-avatar': {
                                    width: 24,
                                    height: 24
                                }
                            }}
                        />
                    );
                })}
            </Stack>
        </Box>
    );
}

